/* ConfigureAuditAction.js */

"use strict";

const ConfigureAuditScreenComponent = require("./ConfigureAuditScreenComponent");

class ConfigureAuditAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, ConfigAuditPolicy, userSession, activityMonitor, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._configAuditPolicy = ConfigAuditPolicy;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this.run = this.run.bind(this);
    }

    run() {
        let auditScreenComponent = new ConfigureAuditScreenComponent(
            this._logger,
            this._gameEditor,
            this._configAuditPolicy,
            this._deviceEntity,
            this._activeView,
            this._modalUserFeedback,
            this._userSession
        );
        //const ActivityMonitor = this._activityMonitor;

        return this._modalUserFeedback.displayCustom(auditScreenComponent, { dontHide: false }).catch((err) => {
            if (err && err.userRejected) {
                this._logger.warn({ error: err }, "ConfigAuditAction.run() - User Canceled");
                return;
            } else {
                this._logger.warn({ error: err }, "ConfigAuditAction.run() - Error");
                return this._modalUserFeedback.displayError(err);
            }
        });
    }
}

module.exports = ConfigureAuditAction;

ConfigureAuditAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.userSession",
    "$teve.activityMonitor",
    "gameEditor.activeView"
];

ConfigureAuditAction.$displayDetails = {
    type: "Action",
    name: "ConfigureAuditAction",
    icon: "configdrift.run_audit",
    shown: true,
    title: "Audit Configuration",
    order: 10
};
